import { createMongoAbility } from '@casl/ability';

export type Actions = 'WRITE' | 'READ';
export type AppSubjects = 'ALL';
export type AMSSubjects =
  | 'ATTRIBUTES_OR_FILTERS_CODE'
  | 'COMMIT_CODE_TO_ATTRIBUTE_LIBRARY'
  | 'DEPLOY'
  | 'EXPERIAN_PROTECTED'
  | 'EXPORT'
  | 'IMPORT'
  | 'UNLOCK_ELEMENTS';
export type AdminSubjects =
  | 'USER'
  | 'BATCH'
  | 'ROLE'
  | 'CLIENT'
  | 'CONFIG'
  | 'DEPLOY'
  | 'PROFILE'
  | 'REMOVE_DATA_SOURCE_IN_ATTRIBUTE_LIBRARY';
export type ToolsSubject =
  | 'ATTRIBUTE_LIBRARY_DELETE'
  | 'ATTRIBUTE_LIBRARY_MANAGE'
  | 'ATTRIBUTE_LIBRARY'
  | 'BATCH_VALIDATION_TOOL'
  | 'RAW_DATA_EDITOR';
export type ViewerSubjects = 'ACCESS' | 'REPORT';

export const ability =
  createMongoAbility<
    [
      Actions,
      AppSubjects | AMSSubjects | AdminSubjects | ToolsSubject | ViewerSubjects
    ]
  >();
